import { useLazyQuery } from "@apollo/client/react";import { useState, useEffect } from 'react';

import { GET_PROFESIONALES_EVALUACION, adaptProfesionales } from '../../../data/graphQL/queries/MisVisitas/getProfesionalesEvaluacion';

export const useGetFilters = (idEvaluacion) => {
  const [profesionales, setProfesionales] = useState([]);
  const [idProfesionalSelected, setIdProfesionalSelected] = useState(0);
  const [idTipoProfesionalSelected, setIdTipoProfesionalSelected] = useState(0);
  const [idFiguraProfesionalSelected, setIdFiguraProfesionalSelected] = useState(0);
  const [figuraProfesionalSelected, setFiguraProfesionalSelected] = useState('');

  const [getProfesionalesEvaluacion, { data: dataProfesionalesEvaluacion, error, loading }] = useLazyQuery(GET_PROFESIONALES_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!dataProfesionalesEvaluacion) return;
    if (!!dataProfesionalesEvaluacion) {
      const dataAdapted = adaptProfesionales(dataProfesionalesEvaluacion || []);
      setProfesionales(dataAdapted);
    }
	}, [dataProfesionalesEvaluacion]);  

  useEffect(() => {
    if (!isNaN(idEvaluacion) && idEvaluacion !== null && !loading)
    getProfesionalesEvaluacion({ variables: { idEvaluacion } });
  }, [idEvaluacion]);

  const handleProfesionalChange = (id, idTipoProfesional, idFiguraProfesional, figuraProfesional) => {
    setIdProfesionalSelected(id);
    setIdTipoProfesionalSelected(idTipoProfesional);
    setIdFiguraProfesionalSelected(idFiguraProfesional);
    setFiguraProfesionalSelected(figuraProfesional);
  };

  return {
    profesionales,
    idProfesionalSelected,
    idTipoProfesionalSelected,
    idFiguraProfesionalSelected,
    figuraProfesionalSelected,
    handleProfesionalChange
  };
};